import { Helmet } from 'react-helmet-async';

import { DriversCards } from './_authenticated._main.driver/DriversCards';
import { DriversTable } from './_authenticated._main.driver/DriversTable';
import { t } from '../services/translation/translation';

export const DriversRoute = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>{t('drivers-route.title')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('drivers-route.title')}</h3>
      <div className="hidden xl:block">
        <DriversTable />
      </div>
      <div className="xl:hidden">
        <DriversCards />
      </div>
    </div>
  );
};
